import Client from "./client";

const baseUrl = `/api/1/deposits`;

function deposits() {
  return {
    getAllDeposits: (pageSize, pageNumber) => {
      return Client.get(baseUrl + `/self/${pageSize}/${pageNumber}`);
    },

    getMyDeposits: (currencyName, pageSize, pageNumber) => {
      return Client.get(
        baseUrl + `/self/${currencyName}/${pageSize}/${pageNumber}`
      );
    },

    syncMyWallet: (currencyName, pageSize, pageNumber) => {
      return Client.get(
        baseUrl + `/syncWallet/${currencyName}/${pageSize}/${pageNumber}`
      );
    }
  };
}

export default deposits();
